function e(e, t, r) {
  return "<" + e + ((n = r) && n.length ? " " + n.map(function (e) {
    return e[0] + '="' + e[1] + '"';
  }).join(" ") : "") + ">" + t + "</" + e + ">";
  var n;
}
function t(e) {
  return (null === e ? "" : e.toString()).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
}
function r(r, o) {
  return function (a) {
    if (!a.properties || !n.valid(a.geometry)) return "";
    var c = n.any(a.geometry);
    if (!c) return "";
    var s = "",
      l = "";
    if (r.simplestyle) {
      var p = function (e) {
        var t = "";
        return e["marker-symbol"] && (t = t + "ms" + e["marker-symbol"]), e["marker-color"] && (t = t + "mc" + e["marker-color"].replace("#", "")), e["marker-size"] && (t = t + "ms" + e["marker-size"]), e.stroke && (t = t + "s" + e.stroke.replace("#", "")), e["stroke-width"] && (t = t + "sw" + e["stroke-width"].toString().replace(".", "")), e["stroke-opacity"] && (t = t + "mo" + e["stroke-opacity"].toString().replace(".", "")), e.fill && (t = t + "f" + e.fill.replace("#", "")), e["fill-opacity"] && (t = t + "fo" + e["fill-opacity"].toString().replace(".", "")), t;
      }(a.properties);
      p && (n.isPoint(a.geometry) && function (e) {
        return !!(e["marker-size"] || e["marker-symbol"] || e["marker-color"]);
      }(a.properties) ? (-1 === o.indexOf(p) && (s = function (t, r) {
        return e("Style", e("IconStyle", e("Icon", e("href", function (e) {
          var t = e["marker-size"] || "medium",
            r = e["marker-symbol"] ? "-" + e["marker-symbol"] : "",
            n = (e["marker-color"] || "7e7e7e").replace("#", "");
          return "https://api.tiles.mapbox.com/v3/marker/pin-" + t.charAt(0) + r + "+" + n + ".png";
        }(t)))) + e("hotSpot", "", [["xunits", "fraction"], ["yunits", "fraction"], ["x", .5], ["y", .5]]), [["id", r]]);
      }(a.properties, p), o.push(p)), l = e("styleUrl", "#" + p)) : (n.isPolygon(a.geometry) || n.isLine(a.geometry)) && function (e) {
        for (var t in e) {
          if ({
            stroke: !0,
            "stroke-opacity": !0,
            "stroke-width": !0,
            fill: !0,
            "fill-opacity": !0
          }[t]) return !0;
        }
      }(a.properties) && (-1 === o.indexOf(p) && (s = function (t, r) {
        var n = e("LineStyle", [e("color", u(t.stroke, t["stroke-opacity"]) || "ff555555") + e("width", void 0 === t["stroke-width"] ? 2 : t["stroke-width"])]),
          o = "";
        return (t.fill || t["fill-opacity"]) && (o = e("PolyStyle", [e("color", u(t.fill, t["fill-opacity"]) || "88555555")])), e("Style", n + o, [["id", r]]);
      }(a.properties, p), o.push(p)), l = e("styleUrl", "#" + p)));
    }
    return s + e("Placemark", function (r, n) {
      return r[n.name] ? e("name", t(r[n.name])) : "";
    }(a.properties, r) + function (r, n) {
      return r[n.description] ? e("description", t(r[n.description])) : "";
    }(a.properties, r) + function (t) {
      return e("ExtendedData", function (e) {
        var t = [];
        for (var r in e) {
          t.push([r, e[r]]);
        }
        return t;
      }(t).map(i).join(""));
    }(a.properties) + function (r, n) {
      return r[n.timestamp] ? e("TimeStamp", e("when", t(r[n.timestamp]))) : "";
    }(a.properties, r) + c + l);
  };
}
var n = {
  Point: function Point(t) {
    return e("Point", e("coordinates", t.coordinates.join(",")));
  },
  LineString: function LineString(t) {
    return e("LineString", e("coordinates", o(t.coordinates)));
  },
  Polygon: function Polygon(t) {
    if (!t.coordinates.length) return "";
    var r = t.coordinates[0],
      n = t.coordinates.slice(1),
      i = e("outerBoundaryIs", e("LinearRing", e("coordinates", o(r)))),
      u = n.map(function (t) {
        return e("innerBoundaryIs", e("LinearRing", e("coordinates", o(t))));
      }).join("");
    return e("Polygon", i + u);
  },
  MultiPoint: function MultiPoint(t) {
    return t.coordinates.length ? e("MultiGeometry", t.coordinates.map(function (e) {
      return n.Point({
        coordinates: e
      });
    }).join("")) : "";
  },
  MultiPolygon: function MultiPolygon(t) {
    return t.coordinates.length ? e("MultiGeometry", t.coordinates.map(function (e) {
      return n.Polygon({
        coordinates: e
      });
    }).join("")) : "";
  },
  MultiLineString: function MultiLineString(t) {
    return t.coordinates.length ? e("MultiGeometry", t.coordinates.map(function (e) {
      return n.LineString({
        coordinates: e
      });
    }).join("")) : "";
  },
  GeometryCollection: function GeometryCollection(t) {
    return e("MultiGeometry", t.geometries.map(n.any).join(""));
  },
  valid: function valid(e) {
    return e && e.type && (e.coordinates || "GeometryCollection" === e.type && e.geometries && e.geometries.every(n.valid));
  },
  any: function any(e) {
    return n[e.type] ? n[e.type](e) : "";
  },
  isPoint: function isPoint(e) {
    return "Point" === e.type || "MultiPoint" === e.type;
  },
  isPolygon: function isPolygon(e) {
    return "Polygon" === e.type || "MultiPolygon" === e.type;
  },
  isLine: function isLine(e) {
    return "LineString" === e.type || "MultiLineString" === e.type;
  }
};
function o(e) {
  return e.map(function (e) {
    return e.join(",");
  }).join(" ");
}
function i(r) {
  return e("Data", e("value", t(r[1])), [["name", t(r[0])]]);
}
function u(e, t) {
  if ("string" != typeof e) return "";
  if (3 === (e = e.replace("#", "").toLowerCase()).length) e = e[0] + e[0] + e[1] + e[1] + e[2] + e[2];else if (6 !== e.length) return "";
  var r = e[0] + e[1],
    n = e[2] + e[3],
    o = e[4] + e[5],
    i = "ff";
  return "number" == typeof t && t >= 0 && t <= 1 && ((i = (255 * t).toString(16)).indexOf(".") > -1 && (i = i.substr(0, i.indexOf("."))), i.length < 2 && (i = "0" + i)), i + o + n + r;
}
export default function (t, n) {
  return '<?xml version="1.0" encoding="UTF-8"?>' + e("kml", e("Document", function (t) {
    return void 0 !== t.documentName ? e("name", t.documentName) : "";
  }(n = n || {
    documentName: void 0,
    documentDescription: void 0,
    name: "name",
    description: "description",
    simplestyle: !1,
    timestamp: "timestamp"
  }) + function (t) {
    return void 0 !== t.documentDescription ? e("description", t.documentDescription) : "";
  }(n) + function (e, t) {
    if (!e.type) return "";
    var n = [];
    switch (e.type) {
      case "FeatureCollection":
        return e.features ? e.features.map(r(t, n)).join("") : "";
      case "Feature":
        return r(t, n)(e);
      default:
        return r(t, n)({
          type: "Feature",
          geometry: e,
          properties: {}
        });
    }
  }(t, n)), [["xmlns", "http://www.opengis.net/kml/2.2"]]);
}